import type { FilterObject } from 'app/filter.utils'
import type { List, ListStage, ListStageInput } from 'app/generated/graphql'

export function isPracticeList(list: Pick<List, `id` | `entityType` | `system`>): boolean {
  return list.entityType === `Contact` && !list.system && !list.id.startsWith(`system:`)
}

export function isFilterList(list: { filters?: readonly object[] | null }): boolean {
  return (list.filters?.length ?? 0) > 0
}

export function defaultStageIdOf(list: Pick<List, `stages` | `defaultStageId`>): string | undefined {
  const stages = list.stages ?? []
  return stages.some((stage) => stage.id === list.defaultStageId) ? list.defaultStageId! : stages[0]?.id
}

export function listItemId(listId: string, entityId: string): string {
  return `${listId}-${entityId}`
}

export function listRuleFilters(list: { filters?: readonly object[] | null }): FilterObject[] {
  return (list.filters ?? []).map(
    ({ __typename: _typename, ...row }: { __typename?: string }) => row as unknown as FilterObject,
  )
}

export function stagesInput(stages: readonly ListStage[]): ListStageInput[] {
  return stages.map(({ id, name, color }) => ({ id, name, color }))
}

export function withListStageAdded(
  stages: readonly ListStage[],
  stage: { name: string; color: string },
): ListStageInput[] {
  return [...stagesInput(stages), { name: stage.name, color: stage.color }]
}

export function withListStageEdited(
  stages: readonly ListStage[],
  stageId: string,
  edit: { name: string; color: string },
): ListStageInput[] {
  return stagesInput(stages).map((stage) => (stage.id === stageId ? { id: stageId, ...edit } : stage))
}

export function withListStageDeleted(stages: readonly ListStage[], stageId: string): ListStageInput[] {
  return stagesInput(stages).filter((stage) => stage.id !== stageId)
}

export function listStageNameTaken(stages: readonly ListStage[], name: string, exceptId?: string): boolean {
  return stages.some((stage) => stage.id !== exceptId && stage.name.toLowerCase() === name.toLowerCase())
}
